import MarkdownRenderer from 'components/MarkdownRenderer'
import { Body20, Title32 } from 'components/Typography'
import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

export const CarouselItem = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  justify-content: center;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: 0 20%;
    max-height: 625px;
    align-items: self-end;
  }
`

export const InfoBox = styled.div`
  position: absolute;
  top: 82%;
  left: 0%;
  width: 70%;
  transform: translateY(-70%);
  padding-top: 40px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 10px;
  background-color: ${(props) => props.theme.colors.backgroundColor};

  ${({ theme }) => theme.mediaQueries.medium} {
    top: 60%;
    left: 8%;
    padding: 40px 50px;
    max-width: 380px;
    border: 1px solid ${(props) => props.theme.colors.secondary};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`

export const ImageContainer = styled(GatsbyImage)`
  width: 100%;
  height: 425px;
  ${({ theme }) => theme.mediaQueries.medium} {
    height: 666px;
  }
  img {
    object-fit: cover;
  }
`

export const Title = styled(Title32)`
  font-family: ${(props) => props.theme.textStyles.fontPrimaryThin};
  font-size: 22px;
  font-style: normal;
  font-weight: 100;
  line-height: 150%; /* 33px */

  ${({ theme }) => theme.mediaQueries.medium} {
    font-family: ${(props) => props.theme.textStyles.fontPrimary};
    font-size: 30px;
    font-weight: 400;
    line-height: 110%;
  }
`

export const Benefit = styled(Body20)`
  font-family: ${(props) => props.theme.textStyles.fontPrimaryThin};
  font-size: 18px;
  font-style: normal;
  font-weight: 100;
  line-height: 150%; /* 27px */
  padding-top: 12px;

  ${({ theme }) => theme.mediaQueries.medium} {
    font-size: 22px;
    font-style: normal;
    font-weight: 100;
    line-height: 150%; /* 33px */
    padding-top: 16px;
  }
`

export const Copy = styled(MarkdownRenderer)`
  padding-top: 50px;
  padding-bottom: 42px;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 150%; /* 21px */
  font-family: ${(props) => props.theme.textStyles.fontMainBody};
`

export const RoundBox = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 42.8px;
  height: 42.8px;
  border: 1px solid ${(props) => props.theme.colors.secondary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`
